export const skillsEn = [
    {
        name: "Special Box Level-Up",
        effect: "When obtaining a Special Box, there is a chance for its level to increase by 1.",
        range: "?? ~ ??"
    },
    {
        name: "Extra Power Limit",
        effect: "The Extra Power limit increases from the previous value of 90.",
        range: "?? ~ ??"
    },
    {
        name: "Daily Mining Limit",
        effect: "The daily mining limit for XPER and PER increases.",
        range: "?? ~ ??"
    },
    {
        name: "Power Storage",
        effect: "The default max storage of the Vehicle Power Storage increases from the previous value of 20.",
        range: "?? ~ ??"
    },
    {
        name: "New Vehicle Breeding Cooldown",
        effect: "The cooldown before using a newly obtained vehicle as a breeding parent is reduced from the original 3 days.",
        range: "?? ~ ??"
    },
    {
        name: "Polished Box",
        effect: "The chance of receiving a vehicle box with the “Polished” trait during breeding increases.",
        range: "?? ~ ??"
    },
    {
        name: "Breed Count",
        effect: "During breeding, there is a chance that the breed count of the parent vehicle will not increase.",
        range: "?? ~ ??"
    },
    {
        name: "Breeding Cooldown",
        effect: "After using a specific vehicle as a breeding parent, the cooldown time until the next breeding is reduced.",
        range: "?? ~ ??"
    },
    {
        name: "New Vehicle Evolution Cooldown",
        effect: "The cooldown before using a newly obtained vehicle as evolution material is reduced from the original 3 days.",
        range: "?? ~ ??"
    },
    {
        name: "Evolution Plus",
        effect: "The chance of obtaining a vehicle with the “Plus” trait during evolution increases.",
        range: "?? ~ ??"
    },
    {
        name: "XPER Bonus",
        effect: "XPER mining bonus is granted based on the base XPER amount in the campaign being played. (Similar to the level 40/45/50 vehicle bonus effects)",
        range: "?? ~ ??"
    },
    {
        name: "New Vehicle Transfer Cooldown",
        effect: "The cooldown before transferring a newly obtained vehicle to the wallet is reduced from the original 3 days.",
        range: "?? ~ ??"
    },
    {
        name: "Vehicle Transfer Fee",
        effect: "The fee required to transfer a vehicle from Spending to Wallet is reduced.",
        range: "?? ~ ??"
    },
    {
        name: "Level-Up Time",
        effect: "Reduced level-up duration for vehicles.",
        range: "?? ~ ??"
    },
    {
        name: "Special Box Open Time",
        effect: "Reduced wait until Special Box can be opened without extra cost.",
        range: "?? ~ ??"
    },
    {
        name: "Basic Daily Reward",
        effect: "Daily mission rewards in Basic Mode are increased.",
        range: "?? ~ ??"
    },
    {
        name: "New Vehicle Sale Cooldown",
        effect: "The cooldown before listing a newly obtained vehicle on the marketplace is reduced from the original 3 days.",
        range: "?? ~ ??"
    },
    {
        name: "New Vehicle Disassembly Cooldown",
        effect: "The cooldown before disassembling a newly obtained vehicle is reduced from the original 3 days.",
        range: "?? ~ ??"
    },
    {
        name: "Rainbow Slot Cooldown",
        effect: "The cooldown for removing a gem from a Rainbow slot is reduced from the original 3 days.",
        range: "?? ~ ??"
    },

]

export const skillsKo = [
    {
        name: "스페셜 박스 레벨업",
        effect: "스페셜 박스 획득 시, 일정 확률로 해당 박스의 레벨이 1 증가합니다.",
        range: "?? ~ ??"
    },
    {
        name: "엑스트라 파워 최대치",
        effect: "엑스트라 파워의 최대치 제한이 기존 90에서 증가합니다.",
        range: "?? ~ ??"
    },
    {
        name: "일일 채굴량 한도",
        effect: "일일 XPER 및 PER 채굴량 한도가 증가합니다.",
        range: "?? ~ ??"
    },
    {
        name: "파워 저장소",
        effect: "차량 파워 저장소의 기본 최대 저장량이 기존 20에서 증가합니다.",
        range: "?? ~ ??"
    },
    {
        name: "신규 차량 브리딩 대기 시간",
        effect: "차량을 획득한 후, 브리딩 부모로 사용할 수 있는 대기 시간이 기존 3일에서 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "반짝이는 상자",
        effect: "브리딩 시, 반짝임 속성이 부여된 차량 박스가 등장할 확률이 증가합니다.",
        range: "?? ~ ??"
    },
    {
        name: "브리드 카운트",
        effect: "브리딩 시, 일정 확률로 부모로 사용된 차량의 브리드 카운트가 증가하지 않습니다.",
        range: "?? ~ ??"
    },
    {
        name: "브리딩 대기 시간",
        effect: "특정 차량을 브리딩 부모로 사용한 후, 다음 브리딩까지 필요한 대기 시간이 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "신규 차량 합성 대기 시간",
        effect: "차량을 획득한 후, 합성 재료로 사용할 수 있는 대기 시간이 기존 3일에서 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "합성 플러스",
        effect: "합성 시, 획득 차량에 플러스 속성이 부여될 확률이 증가합니다.",
        range: "?? ~ ??"
    },
    {
        name: "XPER 보너스",
        effect: "플레이 중인 캠페인의 기본 XPER 채굴량에 비례하여, XPER 채굴 보너스가 주어집니다. (기존 차량의 40/45/50레벨 보너스 효과와 유사)",
        range: "?? ~ ??"
    },
    {
        name: "신규 차량 전송 대기 시간",
        effect: "차량을 획득한 후, 월렛으로 전송할 수 있는 대기 시간이 기존 3일에서 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "차량 전송 수수료",
        effect: "차량을 스펜딩에서 월렛으로 전송할 때 필요한 수수료가 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "레벨업 대기 시간",
        effect: "차량 레벨업 시, 완료까지 필요한 대기 시간이 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "스페셜 박스 대기 시간",
        effect: "스페셜 박스 획득 시, 대기 시간이 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "베이직 일일 보상",
        effect: "베이직 모드의 일일 미션 보상이 증가합니다.",
        range: "?? ~ ??"
    },
    {
        name: "신규 차량 판매 대기 시간",
        effect: "차량을 획득한 후, 마켓에 판매 등록할 수 있는 대기 시간이 기존 3일에서 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "신규 차량 분해 대기 시간",
        effect: "차량을 획득한 후, 분해할 수 있는 대기 시간이 기존 3일에서 감소합니다.",
        range: "?? ~ ??"
    },
    {
        name: "무지개 슬롯 대기 시간",
        effect: "무지개 슬롯에 보석을 장착한 후, 해제까지 필요한 대기 시간이 기존 3일에서 감소합니다.",
        range: "?? ~ ??"
    },
]

export default skillsKo;